.info {
  font-size: 0.81em;
  color: var(--main-text-soft);
  padding-bottom: 5px;
}

.info > div {
  height: 14px;
}

.bold {
  color: var(--button-text);
}
